import './index.scss';
import Nav from 'components/Nav';
import ProductItem from 'components/ProductItem';
import {observer, inject} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
let indexNum = -1,
    leftAds = [4, 10],
    rightAds = [1, 6, 12],
    lAdIndex = 0,
    rAdIndex = 0;
@inject(({store}) => ({
    waterFallData: store.waterFallData,
    tabClick: store.tabClick,
    rxtj: store.rxtj,
    jump: store.jump
}))
@observer
class HotRecommend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leftContent: [],
            rightContent: []
        };
    }

    componentDidUpdate() {
        const {waterFallData = [], rxtj} = this.props;
        const {rxtjad = []} = rxtj;
        if(waterFallData.length && waterFallData[indexNum + 1]) {
            const leftRefs = this.leftRefs.getBoundingClientRect();
            const rightRefs = this.rightRefs.getBoundingClientRect();

            const flag = leftRefs.bottom > rightRefs.bottom;
            const type = flag ? 'rightContent' : 'leftContent';
            let data = waterFallData[indexNum + 1];
            const needShowAds = flag ? (this.state[type].length + 1 === rightAds[rAdIndex]) : (this.state[type].length + 1 === leftAds[lAdIndex]);

            if(needShowAds && rxtjad.length && rxtjad[lAdIndex + rAdIndex]) {
                data = rxtjad[lAdIndex + rAdIndex];
                flag ? (rAdIndex++) : (lAdIndex++);
            } else {
                indexNum ++;
            }
            this.setState({
                [type]: this.state[type].concat([data])
            });
        }
    }

    tabClick(keyName, index) {
        this.props.tabClick('rxtj', keyName, index);
        this.resetData();
    }

    resetData() {
        indexNum = -1;
        lAdIndex = 0;
        rAdIndex = 0;
        this.setState({
            leftContent: [],
            rightContent: []
        });
    }

    pRend(data) {
        const price = data.taocanPrice ? data.taocanPrice : data.price;
        return (
            <div className="pro-info ">
                {
                    data.type === 'ad' && <div className="ad">广告</div>
                }
                {
                    data.title && <div className="tit">{data.title}</div>
                }
                {
                    price && price > 0 && <div className="price-info">
                        <div className="price lr-price">&yen;<span className="num">{data.taocanPrice ? data.taocanPrice : data.price}</span>起</div>
                    </div>
                }
            </div>
        );
    }

    handleImgLoad(e, imgIndex) {
        if(imgIndex === (lAdIndex + rAdIndex)) {
            this.waterFallCaclu(this.props);
        }
    }

    rendeItem(data) {
        const {jump} = this.props;
        return (
            data.map((item, index) => {
                return <ProductItem
                    imgIndex= {lAdIndex + rAdIndex}
                    handleImgLoad={this.handleImgLoad.bind(this)}
                    needShowDate={false}
                    custCls="lr-item"
                    pRendeStatus={true}
                    data={item}
                    jump={() => {
                        jump(item.jumpInfo, 'shuqi_24hrx');
                        sendSK('click_24hrx');
                    }} key={index}
                    pRend={this.pRend.bind(this)}
                />;
            })
        );
    }

    render() {
        const {createRef, rxtj} = this.props;
        let {hrFirstTab, hrSecondTab} = rxtj;

        hrSecondTab.length >= 19 && (hrSecondTab = hrSecondTab.slice(0, 20));
        return (
            <div className="m-hotrecommend" ref={createRef} id="rxtj">
                <ModuleTitle name="rxtj"/>
                {
                    hrFirstTab.length > 1 &&
                    <Nav
                        tabs={hrFirstTab}
                        tabClick={this.tabClick.bind(this)}
                        nWrapCls="c-tab-navwrap"
                        navCls="c-tab-navitem"
                        navClsAct="c-tab-navactive"
                        keyName="hrFirstTab"
                    />
                }
                {
                    hrSecondTab.length > 1 ?
                        <Nav
                            tabs={hrSecondTab}
                            tabClick={this.tabClick.bind(this)}
                            navCls="common-navitem rxtj-item"
                            navClsAct="common-navactive rxtj-active"
                            moreCls="common-navitem rxtj-item"
                            dbackCls="common-drawback rxtj-drawback"
                            keyName="hrSecondTab"
                        /> : ''
                }
                <div className="hr-list">
                    <div className="left" ref={cmp => this.leftRefs = cmp}>
                        {
                            this.rendeItem(this.state.leftContent)
                        }
                    </div>
                    <div className="right" ref={cmp => this.rightRefs = cmp}>
                        {
                            this.rendeItem(this.state.rightContent)
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default HotRecommend;